import RestResource from '../rest.service';

export default class ConceptPaymentTypeService extends RestResource {
  constructor() {
    super('concept-payment-types');
  }
}
